import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/ElectricityCheckoutDataProvider";
import Headline from "../../../../shared/Headline";
import * as styles from "./style.module.scss";

const StepSuccess = () => {
    const dataContext = useContext(DataContext);
    const { loading, orderData } = dataContext.data;

    const orderContactData = {
        team_name: "Hoyer Strom und Erdgas GmbH",
        street: "Rudolf-Diesel-Str. 1",
        zipcode: "27374",
        city: "Visselhövede",
        phone: "+49 4262 799830",
        email: "kundenservice-strom@hoyer.de",
    };

    return (
        <section>
            {loading ? (
                <React.Fragment>
                    <Headline>Ihre Bestellung wird übermittelt</Headline>
                    <p>Haben Sie einen Moment Geduld</p>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Headline>Vielen Dank für Ihre Bestellung</Headline>
                    <div className={styles.contact}>
                        <div className={styles.contactInfo}>
                            <strong>Ihr Team von</strong>
                            <br />
                            {orderContactData.team_name}
                            <br />
                            {orderContactData.street}
                            <br />
                            {orderContactData.zipcode} {orderContactData.city}
                            <br />
                            Tel.: {orderContactData.phone}
                            <br />
                            E-Mail:{" "}
                            <a href={`mailto:${orderContactData.email}`}>
                                {orderContactData.email}
                            </a>
                        </div>
                    </div>
                    {orderData && (
                        <>
                            <p>
                                Ihr Auftrag ist bei uns eingegangen und wird in
                                Kürze bearbeitet.
                            </p>
                            <p>
                                Ihre Auftragsnummer lautet{" "}
                                <strong>
                                    HOY-S-{orderData.customer_no_hoyer_db}
                                </strong>
                                .
                            </p>
                        </>
                    )}
                </React.Fragment>
            )}
        </section>
    );
};

export default StepSuccess;
